import Tooltip from "@8x8/oxygen-tooltip";
import { ExclamationCircleIcon } from "@8x8/oxygen-icon";
import { COLORS } from "@/react/theme/constants";
import React from "react";

export const ErrorWithTooltipIcon = ({ isNameUnique }) =>
  !isNameUnique ? (
    <Tooltip title={"Name must be unique!"}>
      <ExclamationCircleIcon color={COLORS.danger} />
    </Tooltip>
  ) : null;
